import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Grid from "../../assets/Grid.png";
import { motion } from "framer-motion";
import imagw from "../../assets/CTA.webp";

import { Mail, Phone, MapPin } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import DiscoverBlogs from "./DiscoverBlogs";
// import { Script } from "../../Utils/Script";

const Contactus = () => {
  useEffect(() => {
    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);

    const script = document.createElement("script");
    script.src = `https://packky.com/SeoBix/seo_injection.php?webid=cd8435ad15b4e27805d9e08fbaa8d536&url=${encodedUrl}&baseUrl=https%3A%2F%2Fpackky.com`;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [openIndex, setOpenIndex] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const faqs = [
    {
      question:
        "How is Packky (powered by Chaafo) different from other food delivery services?",
      answer:
        "Packky (powered by Chaafo) is a dedicated delivery partner exclusively for restaurants, unlike major aggregators that take a commission on orders. We offer faster deliveries, real-time tracking, lower costs, and full control over your customer experience without third-party interference.",
    },

    {
      question:
        "Does Packky (powered by Chaafo) provide delivery services for all types of restaurants?",
      answer:
        "Yes! Whether you run a fine-dining restaurant, café, cloud kitchen, or quick-service restaurant (QSR), Packky (powered by Chaafo) tailors its delivery solutions to meet your business needs.",
    },

    {
      question:
        "Can I use Packky (powered by Chaafo) without listing my restaurant on third-party platforms?",
      answer:
        "Absolutely! Packky (powered by Chaafo) enables restaurants to deliver directly to customers through their own website, WhatsApp, or social media, eliminating high commissions from food delivery aggregators.",
    },

    {
      question:
        "What happens if a delivery is delayed or an order is incorrect?",
      answer:
        "Packky (powered by Chaafo)’s real-time tracking ensures proactive delivery management. If an order is delayed or incorrect, our dedicated support team intervenes immediately to resolve the issue",
    },

    {
      question:
        "How does Packky (powered by Chaafo) help increase my restaurant’s order volume?",
      answer:
        "We provide faster deliveries, better customer retention, and brand control—leading to higher customer satisfaction and repeat orders. Plus, our optional marketing services can help drive more traffic to your restaurant.",
    },

    {
      question:
        "Is there a minimum order requirement to use Packky (powered by Chaafo)’s delivery service?",
      answer:
        " No, there is no minimum order restriction. We deliver everything from single meals to large bulk orders, making Packky (powered by Chaafo) ideal for both small and large-scale restaurants.",
    },

    {
      question: "What are the delivery charges, and how is pricing structured?",
      answer:
        "Packky (powered by Chaafo) offers flexible pricing based on delivery distance, order volume, and restaurant needs. Unlike other platforms, we provide transparent pricing with no hidden fees.",
    },

    {
      question:
        "Can I integrate Packky (powered by Chaafo) with my restaurant’s website or WhatsApp ordering system?",
      answer:
        "Yes! Packky (powered by Chaafo) seamlessly integrates with your website, WhatsApp ordering system, and POS software, ensuring smooth order processing and automated delivery scheduling.",
    },

    {
      question:
        "What safety measures does Packky (powered by Chaafo) follow for food handling and delivery?",
      answer:
        " We ensure strict hygiene standards, including: Contactless deliveries, Sanitized delivery bags, Trained riders following food safety protocols, Temperature-controlled food transport for heat-sensitive items",
    },

    {
      question:
        "How do I get started with Packky (powered by Chaafo), and how long does onboarding take?",
      answer:
        "Getting started is easy! Simply sign up on our website or contact our team. We offer a quick onboarding process that takes less than 48 hours, so you can start delivering with Packky (powered by Chaafo) immediately.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // useEffect(() => {
  //   Script();
  // }, []);

  return (
    <>
      <Helmet>
        <title>
          {" "}
          Contact Packky — Get Help with Delivery Management Solutions
        </title>

        <meta
          name="description"
          content=" Have questions about Packky? Reach our team at support@packky.com or call +91 . We're based in Noida and here to help your business deliver smarter."
        />
      </Helmet>
      <Navbar />

      <div>
        <section
          className="px-4 pb-16 pt-28 text-center"
          style={{
            background:
              "linear-gradient(180deg, #fff 0, #0000), radial-gradient(circle at 10% 100%, #ff8e8e 5%, #0000 30%), radial-gradient(circle at 40% 100%, #e88cff 5%, #0000 40%), radial-gradient(circle at 90% 100%, #e8ff8c 20%, #0000 60%",
          }}
        >
          <h5 className="contact-subtitle text-[24px] font-bold text-[#AD5BFF] sm:text-[22px] md:text-[26px] lg:text-[28px]">
            CONTACT US
          </h5>

          <h2 className="contact-title1 mx-auto mt-4 max-w-[320px] text-[#212529] text-center text-[22px] font-medium leading-[1.2] sm:max-w-[420px] sm:text-[24px] md:max-w-[520px] md:text-[28px] lg:max-w-[350px] lg:text-[26px]">
            Got questions? We're here to listen and help!
          </h2>

          <p className="contact-subtitle1 mx-auto mt-4 max-w-[990px] font-normal text-[16px] leading-5 md:text-[22px] md:leading-7 text-[#5b6470]">
            From the first idea to full execution, our team is here to support
            you every step of the way. Whether you want to know more about our
            delivery solutions, need help with technical queries, or are looking
            for custom logistics support, just reach out.
          </p>
        </section>

        <div className="contact-container mx-auto mt-10 mb-5 w-full max-w-[1060px] px-4">
          <div
            className="Map-card-paccky rounded-[20px] p-4 md:p-4"
            style={{ background: "#78bff0" }}
          >
            <div className="card bg-white" style={{ borderRadius: "1rem" }}>
              <div className="grid grid-cols-1 md:grid-cols-3">
                <div className="flex items-center px-5">
                  <div className="contact-card contact-column flex w-full flex-row items-center">
                    <div className="mr-4 flex items-center justify-center">
                      <i className="fas fa-phone icon flex h-[38px] w-[38px] items-center justify-center rounded-full bg-[#f6b800] text-white">
                        <Phone className="h-5 w-5 text-white" />
                      </i>
                    </div>
                    <div className="contact-text">
                      <h5 className="mb-1 text-left text-[#212529] text-[18px] font-bold">
                        Call us
                      </h5>
                      <p className="mb-0 text-left text-[15px] text-[#667085]">
                        +91 9650477664
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex items-center px-5 md:border-l md:border-r md:border-[#f6b800]">
                  <div className="contact-card contact-column flex w-full flex-row items-center">
                    <div className="mr-4 flex items-center justify-center">
                      <i className="fas fa-envelope icon flex h-[38px] w-[38px] items-center justify-center rounded-full bg-[#f6b800] text-white">
                        <Mail className="h-5 w-5 text-white" />
                      </i>
                    </div>
                    <div className="contact-text">
                      <h5 className="mb-1 text-left text-[#212529] text-[18px] font-bold">
                        Email us
                      </h5>
                      <p className="mb-0 text-left text-[15px] text-[#667085]">
                        support@packky.com
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex items-center px-5">
                  <div className="contact-card flex w-full flex-row items-center">
                    <div className="mr-4 flex items-center justify-center">
                      <i className="fas fa-map-marker-alt icon flex h-[38px] w-[38px] items-center justify-center rounded-full bg-[#f6b800] text-white">
                        <MapPin className="h-5 w-5 text-white" />
                      </i>
                    </div>
                    <div className="contact-text">
                      <h5 className="mb-1 text-left text-[#212529] text-[18px] font-bold lg:m-2">
                        Visit us
                      </h5>
                      <p className="mb-2 text-left text-[15px] text-[#667085]">
                        3rd Floor, ITHUM TOWER, C - 303, Block A, C, Sector 62,
                        Noida, Uttar Pradesh 201301
                        <br />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="map-container mt-4">
              <iframe
                src="https://www.google.com/maps?q=I-Thum%20Tower%20Noida&output=embed"
                width="100%"
                height="350px"
                style={{ borderRadius: "16px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        <div
          className="flex w-full flex-col"
          style={{
            backgroundImage: `url(${Grid})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundColor: "#EDF3FC",
          }}
        >
          <div className="mx-auto w-full max-w-7xl px-4 py-8 md:py-12">
            <h2
              className="mt-4 mb-8 text-center text-[#212529]"
              style={{ fontSize: "28px", fontWeight: "500" }}
            >
              FAQ&apos;s
            </h2>

            <div className="flex flex-wrap justify-center">
              <div className="w-full md:w-10/12 lg:w-8/12">
                <div
                  className="faq-card mt-5 rounded bg-white p-4 md:p-6"
                  style={{
                    borderRadius: "8px",
                    boxShadow: "0 0 0 rgba(0,0,0,0)",
                  }}
                >
                  {faqs.map((faq, index) => {
                    const isOpen = openIndex === index;

                    return (
                      <div
                        key={index}
                        className="border-b border-gray-200 last:border-b-0"
                      >
                        <div
                          className="flex items-center justify-between py-3"
                          onClick={() => toggleFAQ(index)}
                          style={{ cursor: "pointer" }}
                        >
                          <p
                            className="mb-0 pr-4 font-normal text-[#212529]"
                            style={{ fontSize: "clamp(14px, 4vw, 18px)" }}
                          >
                            {faq.question}
                          </p>

                          <button
                            className="flex shrink-0 items-center justify-center bg-transparent text-[#212529]"
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              fontSize: "1.875rem",
                              lineHeight: 1,
                            }}
                          >
                            {isOpen ? "-" : "+"}
                          </button>
                        </div>

                        {isOpen && (
                          <div
                            className="pb-5 pr-10 font-sf-pro text-gray-500"
                            style={{ fontSize: "clamp(14px, 4vw, 16px)" }}
                          >
                            {faq.answer}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="flex w-full flex-col"
          style={{
            backgroundImage: `url(${Grid})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundColor: " #EDF3FC",
          }}
        >
          <div className="main-box-5 card-h bg-gray-100 p-5">
            <section className="about-p">
              <div className="mx-auto w-full max-w-7xl px-4">
                <div className="flex flex-wrap mt-5">
                  <div className="w-full">
                    <div
                      className="banner-box3 mx-auto rounded-3xl overflow-hidden relative"
                      style={{
                        background:
                          "linear-gradient(-135deg, #FDFEFF 20%, #CEEBFF 70%, #129EFF 100%)",
                        border: "0.5px solid #ccc",
                        minHeight: "300px",
                        maxWidth: "1200px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                      }}
                    >
                      <div className="flex flex-wrap h-full">
                        <div className="w-full md:w-1/2 lg:w-7/12 flex flex-col justify-center p-4 md:p-5">
                          <h4 className="text-[#212529] max-w-md ml-5 text-2xl md:text-[28px] font-bold mb-3">
                            Join the Future of Delivery
                          </h4>
                          <p className="text-gray-600 md:text-[18px] ml-5">
                            At Packky (powered by Chaafo), we are more than just
                            a service. We're your logistics partner. We're your
                            partner in need when you're looking for last-mile
                            delivery solutions, fleet management, or the smooth
                            integration of your existing systems.
                            <br />
                            Let's advance the world one delivery at a time.
                          </p>

                          <button className="mt-6 ml-5 mb-6 w-fit text-[#0d6efd] flex items-center rounded-full bg-white px-3 py-1.5 text-base font-bold">
                            Sign Up for Free →
                          </button>
                        </div>

                        <div className="w-[95%] pl-5  md:w-1/2 lg:w-5/12 flex items-end justify-center relative">
                          <img
                            src={imagw}
                            alt="Service"
                            className="h-auto max-w-full"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <DiscoverBlogs />

      <Footer />
    </>
  );
};

export default Contactus;
